module.exports = __webpack_public_path__ + "img/ardoise_noir.b3c40785.jpg";